var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core';
var useStyles = makeStyles(function (theme) {
    return createStyles({
        root: {
            textAlign: "center",
            padding: 12,
            whiteSpace: "nowrap",
            '& > *': {
                margin: theme.spacing(1),
                // borderRadius: "20px",
                fontSize: "1.2em",
                minWidth: 90,
            },
        },
    });
});
export var ButtonBar = function (props) {
    var classes = useStyles();
    return React.createElement("div", __assign({ className: classes.root }, props), props.children);
};
